module.exports = __webpack_public_path__ + "img/img4.a5a96543.png";